









































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Achat, Livraison} from '@/models';

import CrudLivraisonEdit from '@/components/Crud/Livraison/Edit.vue';
import storeAchat from "@/stores/modules/achat";
import {Stored} from "vue-stored-prop-decorator/index";

@Component({
	components: {
		CrudLivraisonEdit,
	}
})
export default class CrudLivraisonEditDialog extends Vue {
	@Stored(() => storeAchat)
		private achat: Achat;
	@InOut({ type: Livraison  , isVModel: true }) private value!: Livraison;

	@Emit()
	private onSubmit(livraison: Livraison) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}

	@Emit()
	private async onAnnuler(): Promise<void> {
		this.value = null;
	}
}
